import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import loanFormModel from '../../form_models/loanFormModel';
import { Rule } from '../../interfaces/Rule';

const { primaryMotivationForSolar } = loanFormModel.formField;

export class PrimaryMotivationForSolarIsOther implements Rule {
  public evaluate(data: Partial<ApplicationFormValues>): boolean {
    const selectedOther = data[primaryMotivationForSolar.name] === 'Other';

    return selectedOther;
  }
}

export default new PrimaryMotivationForSolarIsOther();
